import { Link, useParams } from 'react-router';
import { useTemplate } from '../../api/queries';
import { ErrorState, Spinner } from '../../components/ui';
import { errorMessage } from '../../lib/api';
import { FormRenderer } from '../form/FormRenderer';

export function TemplatePreviewPage() {
  const { id = '' } = useParams();
  const { data: template, isPending, error } = useTemplate(id);

  if (isPending) return <Spinner />;
  if (error) return <ErrorState message={errorMessage(error)} />;

  return (
    <div className="preview">
      <div className="preview-banner">
        <span>
          <strong>Preview</strong> — this is what clients will see. Answers are not saved.
        </span>
        <Link to={`/admin/templates/${template.id}`} className="btn btn-secondary btn-sm">
          Back to editor
        </Link>
      </div>
      <FormRenderer form={template} clientName="Client name" preview />
    </div>
  );
}
